// Single source of truth for raw design values.
// Everything else in the theme references these.

export const colors = {
    // Surfaces — deep charcoal, not pure black (less harsh)
    surface: {
        base: '#0b0d10',        // app background
        raised: '#14171c',      // cards, papers
        elevated: '#1a1e24',    // hover, dropdowns, menus
        subtle: '#0f1114',      // subtle panels, inputs
        overlay: 'rgba(0,0,0,0.6)',
    },

    // Borders — Stripe/Linear rely heavily on soft borders
    border: {
        subtle: 'rgba(255,255,255,0.06)',
        default: 'rgba(255,255,255,0.10)',
        strong: 'rgba(255,255,255,0.15)',
        focus: 'rgba(99,102,241,0.45)',
    },

    // Text hierarchy
    text: {
        primary: '#ffffff',
        secondary: '#9ca3af',
        muted: '#6b7280',
        disabled: '#4b5563',
        link: '#818cf8',
    },

    // Primary accent — refined indigo (Linear-esque)
    primary: {
        50:  '#eef2ff',
        100: '#e0e7ff',
        300: '#a5b4fc',
        400: '#818cf8',
        500: '#6366f1',
        600: '#4f46e5',
        700: '#4338ca',
    },

    // Performance — used ONLY for genuine positive/negative signals (ROI sign)
    performance: {
        positive: '#22c55e',
        positiveBg: 'rgba(34,197,94,0.1)',
        positiveBorder: 'rgba(34,197,94,0.25)',
        negative: '#ef4444',
        negativeBg: 'rgba(239,68,68,0.1)',
        negativeBorder: 'rgba(239,68,68,0.25)',
        neutral: '#9ca3af',
    },

    // Direction indicators (buy vs sell) — NEUTRAL, no moral weight
    direction: {
        buyFg:     '#a5b4fc',
        buyBg:     'rgba(99,102,241,0.22)',
        buyBorder: 'rgba(129,140,248,0.45)',
        sellFg:    '#cbd5e1',
        sellBg:    'rgba(148,163,184,0.18)',
        sellBorder:'rgba(148,163,184,0.35)',
    },

    // Political affiliation — only on party indicators
    party: {
        democrat: '#3b82f6',
        republican: '#ef4444',
        independent: '#9ca3af',
    },

    // Status (e.g. "Current" tenure, "Active" subscription)
    status: {
        active: '#818cf8',
        activeBg: 'rgba(99,102,241,0.15)',
        inactive: 'rgba(156,163,175,0.5)',
    },
};

export const radius = {
    sm: 6,
    md: 8,
    lg: 12,
    xl: 16,
    full: 9999,
};

// MUI spacing units (1 = 8px)
export const spacing = {
    section: 5,
    card: 3,
    cardCompact: 2,
    inner: 1.5,
    tight: 1,
};

export const shadows = {
    sm: '0 1px 2px rgba(0,0,0,0.3), 0 1px 1px rgba(0,0,0,0.2)',
    md: '0 4px 12px rgba(0,0,0,0.3), 0 2px 4px rgba(0,0,0,0.2)',
    lg: '0 10px 30px rgba(0,0,0,0.35), 0 4px 8px rgba(0,0,0,0.25)',
    focus: `0 0 0 3px ${colors.border.focus}`,
};

export const transitions = {
    fast: '150ms cubic-bezier(0.4, 0, 0.2, 1)',
    base: '200ms cubic-bezier(0.4, 0, 0.2, 1)',
    slow: '300ms cubic-bezier(0.4, 0, 0.2, 1)',
};

export const fonts = {
    sans: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    mono: '"JetBrains Mono", ui-monospace, "SF Mono", Menlo, monospace',
};
